import { Button } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { ModalConfirm } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { CircleCheckIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import ConditionalTooltip from '../../../components/ConditionalTooltip';
import useIntl from '../../../hooks/useIntl';
import messages from './messages';
import { usePostPaymentsAndDepositsModal } from './hooks';

const PostPaymentsAndDepositsModal = ({
  disabled = false,
  disabledTooltip,
  onMarkAsPaid,
}) => {
  const intl = useIntl();
  const { open, handleOpen, handleClose, actionsProps } =
    usePostPaymentsAndDepositsModal({ onMarkAsPaid });

  return (
    <>
      <ConditionalTooltip
        show={disabled}
        title={disabledTooltip ?? intl.formatMessage(messages.disabledTooltip)}
        placement="top"
      >
        <Button
          variant="primary"
          onClick={handleOpen}
          disabled={disabled}
          startIcon={<CircleCheckIcon />}
        >
          {intl.formatMessage(messages.postPaymentsAndDeposits)}
        </Button>
      </ConditionalTooltip>

      <ModalConfirm
        open={open}
        onClose={handleClose}
        title={intl.formatMessage(messages.modalTitle)}
        actionsProps={actionsProps}
      >
        {intl.formatMessage(messages.confirmationMessage)}
      </ModalConfirm>
    </>
  );
};

export default PostPaymentsAndDepositsModal;
